// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import 'babel-polyfill'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
// import 'view-design/dist/styles/iview.css';
// import VueResource from 'vue-resource'
import 'vue-ydui/dist/ydui.base.css'
// import visibility from 'vue-visibility-change';
// Vue.use(visibility);
import ZkTable from 'vue-table-with-tree-grid'
import selectTree from 'iview-select-tree'
import App from './App'
import store from './store'
import router from './router'
Vue.use(ZkTable)
Vue.use(selectTree)
Vue.config.productionTip = false
Vue.use(iView)
// Vue.use(VueResource)
/* eslint-disable no-new */
// visibility.change((evt, hidden) => {
//     console.log('global callback: ' + hidden);
//     if(hidden === false) {
//         location.reload();
//     }
// });
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'

})



// WEBPACK FOOTER //
// ./src/main.js